import React from 'react';
import { XIcon } from '@heroicons/react/outline';
import { RuleItem } from 'types/plans';
import { useStore } from 'context/store-context';
import { getStoreCurrencyFormatter } from 'utils';
import { NonNegativeNumberInput } from 'components/NonNegativeNumberInput';

type FixedRuleProps = {
  onRemoveItem: () => void;
  rule: RuleItem;
  onChange: (field: string, value: string) => void;
  disabled?: boolean;
};

export const FixedRule = ({
  onRemoveItem,
  rule,
  onChange,
  disabled,
}: FixedRuleProps) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: string,
  ) => {
    const { value } = e.target;

    onChange(field, value);
  };
  const { storeProperties } = useStore();

  return (
    <div className="grid gap-4 rounded-lg border border-[#e5ebf4] bg-white p-4 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
      <div>
        <label className="mb-2 block text-xs font-bold uppercase tracking-wide text-[#737686]">
          Price range
        </label>
        <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3">
          <NonNegativeNumberInput
            name="rangeLower"
            className="w-full rounded-lg border border-[#d8dfeb] bg-white px-3 py-2 text-sm text-[#0b1c30] shadow-sm focus:border-[#2563eb] focus:ring-1 focus:ring-[#2563eb] disabled:bg-slate-100 disabled:text-slate-400"
            placeholder="0"
            value={rule.rangeLower}
            onChange={(e) => handleChange(e, 'rangeLower')}
            min={0}
            disabled={disabled}
          />
          <span className="text-sm font-semibold text-[#737686]">to</span>
          <NonNegativeNumberInput
            name="rangeUpper"
            className="w-full rounded-lg border border-[#d8dfeb] bg-white px-3 py-2 text-sm text-[#0b1c30] shadow-sm focus:border-[#2563eb] focus:ring-1 focus:ring-[#2563eb] disabled:bg-slate-100 disabled:text-slate-400"
            placeholder="100"
            value={rule.rangeUpper}
            onChange={(e) => handleChange(e, 'rangeUpper')}
            min={0}
            disabled={disabled}
          />
        </div>
      </div>
      <div>
        <label className="mb-2 block text-xs font-bold uppercase tracking-wide text-[#737686]">
          Guarantee fee
        </label>
        <NonNegativeNumberInput
          name="fee"
          className="w-full rounded-lg border border-[#d8dfeb] bg-white px-3 py-2 text-sm text-[#0b1c30] shadow-sm focus:border-[#2563eb] focus:ring-1 focus:ring-[#2563eb] disabled:bg-slate-100 disabled:text-slate-400"
          placeholder={`e.g ${getStoreCurrencyFormatter(
            storeProperties?.currency,
            3,
          )}`}
          value={rule.fee}
          onChange={(e) => handleChange(e, 'fee')}
          disabled={disabled}
        />
      </div>
      <button
        type="button"
        className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-[#fee2e2] bg-[#fff1f2] text-[#dc2626] transition hover:bg-[#ffe4e6] disabled:cursor-not-allowed disabled:opacity-50"
        onClick={!disabled ? onRemoveItem : () => {}}
        disabled={disabled}
        aria-label="Remove rule"
      >
        <XIcon className="h-5 w-5" />
      </button>
    </div>
  );
};
